import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import { BankIDInputMeta, CorporateNameInputMeta } from "../../../forms/commonMeta";

export interface IParameterValuesFormMeta {
    bankID: FormInputMeta;
    corporateName: FormInputMeta;
    id: FormInputMeta;
    parameterConfiguration: FormInputMeta;
    
    schema: any;
}

const parameterValuesFormMeta = {} as IParameterValuesFormMeta;

parameterValuesFormMeta.bankID = {...BankIDInputMeta, label: "ID Banque"};

parameterValuesFormMeta.corporateName = {...CorporateNameInputMeta, label: "Raison Sociale"};

parameterValuesFormMeta.id = {
  name: "id",
  type: "text",
  label: "ID",
  placeholder: "Veuillez entrer l'ID",
  validation: yup.string().required("Champ obligatoire !")
};

parameterValuesFormMeta.parameterConfiguration = {
  name: "parameterConfiguration",
  type: "text",
  label: "Configuration Paramètres",
  placeholder: "Veuillez entrer la configuration paramètres",
  validation: yup.string().required("Champ obligatoire !")
};

parameterValuesFormMeta.schema = yup.object().shape(getValidationSchema(parameterValuesFormMeta));

export default parameterValuesFormMeta; 